const trackedLink = (x)=>`http://hongbaoshu.com/mobile-app/link.html?to=${x}`
export const links = {
    写作: trackedLink('写作'),
    词汇: trackedLink('词汇'),
    真题: trackedLink('真题'),
    增值服务: trackedLink('增值服务'),
    淘宝: "http://hongbaoshu.com/mobile-app/store",
    京东: trackedLink('京东'),
    苹果下载: trackedLink('苹果下载'),
    安卓下载: trackedLink('安卓下载'),
    备案: 'https://beian.miit.gov.cn/',
}
